export default "__VITE_ASSET__DPdMu7cw__"